<template>
  <v-banner
    v-if="isViewOnlyMode"
    color="blue lighten-4"
    elevation="2"
    class="view-only-banner"
    sticky
  >
    <v-avatar
      slot="icon"
      color="blue lighten-2"
      size="40"
    >
      <v-icon color="white">
        mdi-eye
      </v-icon>
    </v-avatar>

    <div class="d-flex align-center justify-space-between flex-grow-1">
      <div>
        <div class="text-subtitle-1 font-weight-bold blue--text text--darken-3">
          Modo Visualização
        </div>
        <div class="text-body-2 blue--text text--darken-2">
          Você está visualizando os dados de <strong>{{ managerName }}</strong> ({{ managerRole }}).
          Modo somente leitura.
        </div>
      </div>

      <v-btn
        color="blue darken-1"
        outlined
        @click="switchManager"
      >
        <v-icon left>
          mdi-account-switch
        </v-icon>
        Trocar gestor
      </v-btn>
    </div>
  </v-banner>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ViewOnlyBanner',
  
  computed: {
    ...mapGetters(['isViewOnlyMode', 'viewOnlyManagerName', 'viewOnlyManagerRole']),
    
    managerName() {
      return this.viewOnlyManagerName || 'Gestor'
    },
    
    managerRole() {
      return this.viewOnlyManagerRole || 'Departamento'
    }
  },
  
  methods: {
    switchManager() {
      this.$router.push('/tenant-admin')
    }
  }
}
</script>

<style scoped>
.view-only-banner {
  position: sticky;
  top: 64px;
  z-index: 5;
}
</style>
